(function () {
  var SECTION_SELECTOR = '.oddit-section-filter-sidebar';

  function initSection(section) {
    if (!section || section.dataset.odditInitialized === 'true') return;
    section.dataset.odditInitialized = 'true';

    var toggles = section.querySelectorAll('[data-filter-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', handleToggleClick);
    }

    var lists = section.querySelectorAll('[data-filter-options]');
    for (var l = 0; l < lists.length; l++) {
      setupOptionList(lists[l]);
    }

    // Applied-filter chips and "Clear all" are real navigation links
    // (Shopify Search & Discovery url_to_remove / collection.url), so no JS hijacking.

    var closeBtn = section.querySelector('[data-filter-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        section.dispatchEvent(new CustomEvent('oddit:filter-drawer:close', { bubbles: true }));
      });
    }

    setupResultsCount(section);
  }

  function setupResultsCount(section) {
    var form = section.querySelector('[data-filter-form]');
    var cta = section.querySelector('[data-filter-results-cta]');
    if (!form || !cta || typeof window.fetch !== 'function') return;

    var template = cta.getAttribute('data-filter-results-template') || 'Show X Results';
    var sectionId = form.getAttribute('data-filter-section-id');
    if (!sectionId) return;

    var lastGoodText = cta.textContent.trim();
    var debounceTimer = null;
    var requestToken = 0;

    function renderCount(count) {
      lastGoodText = template.replace('X', String(count));
      cta.textContent = lastGoodText;
    }

    function setPending(pending) {
      cta.classList.toggle('oddit-section-filter-sidebar__cta--pending', pending);
      if (pending) {
        cta.setAttribute('aria-busy', 'true');
      } else {
        cta.removeAttribute('aria-busy');
      }
    }

    function currentParams() {
      var params = new URLSearchParams(new FormData(form));
      var cleaned = new URLSearchParams();
      params.forEach(function (value, key) {
        if (value !== '') cleaned.append(key, value);
      });
      return cleaned;
    }

    function update() {
      var token = ++requestToken;
      var params = currentParams();
      params.set('section_id', sectionId);

      setPending(true);

      fetch(form.getAttribute('action') + '?' + params.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.text();
        })
        .then(function (html) {
          if (token !== requestToken) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var countEl = doc.querySelector('.oddit-section-main-collection-grid__product-count');
          if (!countEl) return;
          var match = countEl.textContent.replace(/,/g, '').match(/\d+/);
          if (match) renderCount(match[0]);
        })
        .catch(function () {
          if (token === requestToken) cta.textContent = lastGoodText;
        })
        .finally(function () {
          if (token === requestToken) setPending(false);
        });
    }

    function queueUpdate() {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(update, 120);
    }

    form.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.name) return;
      queueUpdate();
    });

    form.addEventListener('input', function (e) {
      var target = e.target;
      if (!target || !target.name || target.type !== 'number') return;
      queueUpdate();
    });
  }

  function handleToggleClick(e) {
    var button = e.currentTarget;
    var group = button.closest('.oddit-section-filter-sidebar__group');
    if (!group) return;

    var expanded = button.getAttribute('aria-expanded') === 'true';
    var nextExpanded = !expanded;
    button.setAttribute('aria-expanded', String(nextExpanded));
    group.classList.toggle('oddit-section-filter-sidebar__group--open', nextExpanded);

    var bodyId = button.getAttribute('aria-controls');
    var body = bodyId ? document.getElementById(bodyId) : null;
    if (body) {
      if (nextExpanded) {
        body.removeAttribute('hidden');
      } else {
        body.setAttribute('hidden', '');
      }
    }
  }

  // Adds client-side option search + "See more" collapsing to a long filter list.
  function setupOptionList(list) {
    var limit = parseInt(list.getAttribute('data-filter-limit'), 10) || 0;
    var options = list.querySelectorAll('[data-filter-option]');
    var group = list.closest('.oddit-section-filter-sidebar__group');
    var search = group ? group.querySelector('[data-filter-search]') : null;
    var seeMore = group ? group.querySelector('[data-filter-see-more]') : null;
    var seeMoreText = seeMore ? seeMore.querySelector('[data-filter-see-more-text]') : null;
    var expanded = false;

    function render() {
      var query = search ? search.value.trim().toLowerCase() : '';
      var searching = query !== '';
      var shown = 0;

      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var label = opt.getAttribute('data-filter-label') || '';
        var matches = !searching || label.indexOf(query) !== -1;
        var visible;
        if (!matches) {
          visible = false;
        } else if (searching || expanded || limit === 0) {
          visible = true;
        } else {
          visible = shown < limit;
        }
        opt.style.display = visible ? '' : 'none';
        if (matches) shown++;
      }

      if (seeMore) {
        // Only relevant when not searching and there are more matches than the limit.
        if (!searching && shown > limit) {
          seeMore.style.display = '';
          seeMore.setAttribute('aria-expanded', String(expanded));
          if (seeMoreText) {
            seeMoreText.textContent = expanded ? 'See less' : 'See more (' + (shown - limit) + ')';
          }
        } else {
          seeMore.style.display = 'none';
        }
      }
    }

    if (search) {
      search.addEventListener('input', render);
      // The option search is client-side only; don't let Enter submit the filter form.
      search.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) e.preventDefault();
      });
    }
    if (seeMore) {
      seeMore.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
    }

    render();
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();